<template>
  <div>
    <edit-form
      ref="editForm"
      :disabled="isDisableEditForm"
      :isConfirmEdit="isConfirmEdit"
      :amzPriceControlCode="params.amzPriceControlCode"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-base-amzPriceControl-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isConfirmEdit() {
      return this.pageType === 'confirmEdit'
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {},
}
</script>
